import React, { useMemo, ReactNode } from 'react';
import styled, {css} from 'styled-components';

import SbEditable from 'components/SbEditableExtended';
import StoryblokClient from 'storyblok-js-client';

import ContentWrapper from 'components/contentWrapper';
import ContentArea from 'components/contentArea';

import config from 'settings/config';
import theme, {bp, color} from 'settings/theme';

import calculateBottomSpacingClass from 'components/blocks/utils/calculateBottomSpacingClass';


let Storyblok = new StoryblokClient({
  accessToken: config.storyBlok.publicToken
});


const createImageUrl = (origUrl, width) => {

  const url = origUrl && typeof origUrl === 'string' ? `${origUrl}/m/${width}x0/smart` : '';

  // console.log("Width", width)
  // console.log("Orig URL", origUrl)
  // console.log("Image URL", url)

  return url;

}

type Props = {
  block: any,
  renderContent?: (() => ReactNode) | null
}

// Component
const Component: React.FC<Props> = (props) => {
  
  const spacingBottomClass = useMemo(() => calculateBottomSpacingClass(props.block?.bottom_spacing), [props.block?.bottom_spacing]);
  const imageUrl = props.block?.header_image?.filename || props.block?.header_image;


  if(!props.block){
    return(<div>Storyblok block missing</div>);
  }

	return(
    <SbEditable content={props.block}>
      <StyledComponent {...props} className={`blockHeaderWhiteBox ${spacingBottomClass}`}>

        {/* Image */}
        <img 
          src={createImageUrl(imageUrl, 375)} 
          srcSet={`
            ${createImageUrl(imageUrl, 375)} 375w,
            ${createImageUrl(imageUrl, 640)} 640w,
            ${createImageUrl(imageUrl, 960)} 960w,
            ${createImageUrl(imageUrl, 1200)} 1200w,
            ${createImageUrl(imageUrl, 1400)} 1400w
          `}
          sizes={`
            100vw
          `}
          width="1400"
          height="529"
          className="blockHeaderWhiteBox-headerImage"
          alt={props.block.header_alt_text ?? 'Header Image'}
        />

        {/* Content */}

        <ContentWrapper>

          <div className="blockHeaderWhiteBox-box">
          
            <ContentWrapper>

              {props.block.title &&
                <h1>{props.block.title}</h1>
              }

              {props.block.subtitle &&
                <div className="blockHeaderWhiteBox-subtitle">
                  {props.block.subtitle}
                </div>
              }
              
              {props.block.intro &&
                <div className="blockHeaderWhiteBox-intro">

                  {typeof props.block.intro === 'string' &&
                    <div>{props.block.intro}</div>
                  }

                  {props.block.intro?.content &&
                    <div className="content" dangerouslySetInnerHTML={{__html: Storyblok.richTextResolver.render(props.block.intro)}} />
                  }
                    
                </div>
              }

              {/* Render Content (when content isn't coming from Storyblok) */}
              {props.renderContent && props.block.intro &&
                <div className="blockHeaderWhiteBox-renderContent">
                  {props.renderContent()}
                </div>
              }

            </ContentWrapper>

            {/* Storyblok Content */}
            {props.block.content &&
              <div className="blockHeaderWhiteBox-content">
                <ContentArea  content={props.block.content} />
              </div>
            } 
            
          </div>

        </ContentWrapper>

      </StyledComponent>
    </SbEditable>
	)

}

export default Component


// Styles
const StyledComponent = styled.div`

  .blockHeaderWhiteBox-headerImage{
    z-index: -1;
    width: 100%;
    height: auto;
    max-height: 500px;
    object-fit: cover;
  }

  .blockHeaderWhiteBox-box{
    position:relative;
    min-height: 80px;
    margin-top: -40px;
    padding-top: 20px;
    padding-bottom: 20px;
    border-bottom: solid 1px ${color.lines};
    background-color: white;
  }

  h1{
    font-size: 20px;
    font-weight: normal;
    line-height: 1.3;
  }

  .blockHeaderWhiteBox-subtitle{
    font-family: ${theme.typography.fontFamilySecondary};
    font-weight: bold;
    margin-top: 0.2em;
  }

  .blockHeaderWhiteBox-intro{
    margin-top: 1em;
  }

  .blockHeaderWhiteBox-content{
    margin-top: 2em;
    margin-bottom: -20px;
  }

  .blockHeaderWhiteBox-renderContent{
    margin-top: 2em;
  }


  @media (min-width: ${bp(3)}) {

    .blockHeaderWhiteBox-box{
      min-height: 120px;
      margin-top: -70px;
      padding-top: 40px;
      padding-bottom: 40px;
    }

    h1{
      font-size: 24px;
      font-weight: bold;
      line-height: 1.3;
    }

    .blockHeaderWhiteBox-subtitle{
      margin-top: 0.2em;
    }

    .blockHeaderWhiteBox-intro{
      margin-top: 1em;
    }

    .blockHeaderWhiteBox-content{
      margin-top: 2em;
      margin-bottom: -40px;
    }

  }

  @media (min-width: ${bp(4)}) {

  }


`